var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "@react-components/primitives/Forms/Checkbox/Checkbox";
var FieldError = function (_a) {
    var _b, _c;
    var fieldState = _a.fieldState, children = _a.children;
    if (!(fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid) && !((_b = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _b === void 0 ? void 0 : _b.message))
        return null;
    return (_jsxs(_Fragment, { children: [children, _jsx("div", { style: {
                    color: "red",
                    marginTop: "8px",
                }, children: ((_c = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _c === void 0 ? void 0 : _c.message) && (fieldState === null || fieldState === void 0 ? void 0 : fieldState.error.message) })] }));
};
var RenderFormField = function (_a) {
    var Component = _a.as, field = _a.field, onValueChangeHandler = _a.onValueChangeHandler;
    switch (typeof Component) {
        case typeof Checkbox:
            return (_jsx(Checkbox, __assign({ id: field.name, checked: !!field.value, onCheckedChange: function (value) {
                    field.onChange(value);
                    onValueChangeHandler &&
                        onValueChangeHandler(field.name, value);
                } }, field)));
    }
    return null;
};
var FormField = function (_a) {
    var Component = _a.as, render = _a.render, onValueChangeHandler = _a.onValueChangeHandler, otherProps = __rest(_a, ["as", "render", "onValueChangeHandler"]);
    var control = useFormContext().control;
    return (_jsx(Controller, __assign({}, otherProps, { control: control, render: function (data) {
            return render ? (_jsxs(_Fragment, { children: [render(data), _jsx(FieldError, { fieldState: data.fieldState })] })) : Component ? (_jsxs(_Fragment, { children: [_jsx(RenderFormField, __assign({ as: Component, field: data.field }, (onValueChangeHandler && {
                        onValueChangeHandler: onValueChangeHandler,
                    }))), _jsx(FieldError, { fieldState: data.fieldState })] })) : (_jsx(_Fragment, {}));
        } })));
};
export { FormField };
